<div id="quizGame" *ngIf="label && quizList">

  <div class="row mx-0 justify-content-center" *ngIf="quizNum > 0">
    <div class="col-12 col-md-auto pt-3">
      <div class="gameTitle gameTitleSm {{lang}}">{{ label[lang].quizGame }}</div>
    </div>
    <div class="col text-left text-md-right align-self-center mb-3 mb-lg-0">

      <div class="quizPagin">
        <!-- {{ label[lang].num }} {{ quizNum }} {{ label[lang].ques }}, {{ label[lang].total }} {{ quizList.length }}
        {{ label[lang].ques }} -->
        <ng-container *ngIf="lang === 'tc'">
          {{ label[lang].num }} {{ quizNum }} {{ label[lang].ques }}, {{ label[lang].total }} {{ quizList.length }}
          {{ label[lang].ques }}
        </ng-container>
        <ng-container *ngIf="lang === 'sc'">
          {{ label[lang].num }} {{ quizNum }} {{ label[lang].ques }}, {{ label[lang].total }} {{ quizList.length }}
          {{ label[lang].ques }}
        </ng-container>
        <ng-container *ngIf="lang === 'en'">
          {{ label[lang].num }} {{ quizNum }}, {{ label[lang].total }} {{ quizList.length }}
          {{ label[lang].ques }}s
        </ng-container>
      </div>

      <ng-container *ngIf="lang === 'tc'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_tc.png" (click)="gameReset()" />
      </ng-container>
      <ng-container *ngIf="lang === 'sc'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_sc.png" (click)="gameReset()" />
      </ng-container>
      <ng-container *ngIf="lang === 'en'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_en.png" (click)="gameReset()" />
      </ng-container>

    </div>
  </div>

  <div class="quizGameWrap {{ lang }}" [ngClass]="{'firstBg': quizNum === 0}">
    <div>

      <div class="row mx-0 justify-content-center" *ngIf="quizNum === 0 && !showResult">
        <div class="col-12 col-md-11 col-lg-8 mb-3 mb-lg-0">

          <div class="ruleDesc">
            <div class="gameTitle {{lang}}">{{ label[lang].quizGame }}</div>
            <div>
              <label class="{{lang}}">{{ label[lang].gameRule }}</label>
            </div>
            <div>
              {{ label[lang].game1Landing1 }}<br />
              {{ label[lang].game1Landing2 }}<br />
              <br />
            </div>
            <!-- <ul>
              <li>遊戲規則 1 遊戲規則 1 遊戲規則 1</li>
              <li>遊戲規則 2 遊戲規則 2 遊戲規則 2</li>
              <li>遊戲規則 3 遊戲規則 3 遊戲規則 3</li>
            </ul> -->

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_tc.png" (click)="gameStart()">
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_sc.png" (click)="gameStart()">
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_en.png" (click)="gameStart()">
            </ng-container>

          </div>

        </div>
      </div>

      <div class="row mx-0 justify-content-center" *ngIf="quizNum > 0 && !showResult">
        <div class="col-12 col-md-12 col-lg-10">

          <div class="quesBlock row mx-0 {{ lang }}">
            <div class="col-12 col-md-auto">

              <ng-container *ngIf="lang === 'tc'">
                {{ label[lang].num }} {{ quizNum }} {{ label[lang].ques }}:
              </ng-container>
              <ng-container *ngIf="lang === 'sc'">
                {{ label[lang].num }} {{ quizNum }} {{ label[lang].ques }}:
              </ng-container>
              <ng-container *ngIf="lang === 'en'">
                {{ label[lang].num }} {{ quizNum }}:
              </ng-container>

            </div>
            <div class="col">
              <ng-container *ngIf="lang === 'tc'">
                {{ quizList[quizNum-1].questionTc }}
              </ng-container>
              <ng-container *ngIf="lang === 'sc'">
                {{ quizList[quizNum-1].questionSc }}
              </ng-container>
              <ng-container *ngIf="lang === 'en'">
                {{ quizList[quizNum-1].questionEn }}
              </ng-container>
            </div>
          </div>

          <div class="row">
            <ng-container *ngIf="lang === 'tc'">
              <div class="col-12 col-md-4 col-lg-3 mb-4 mb-lg-5"
                *ngFor="let ans of quizList[quizNum-1].ansTc; let key = index;">

                <div class="ansBlock {{ getAnsBlockHeightStyle(quizList[quizNum-1]) }}" [ngClass]="{'pointer': !showAns, 'selectedAns': !showAns && ans === userSelectAns, 'disableAns': showAns && userSelectAns !== ans && ans !== quizList[quizNum-1].corrAnsTc, 'wrongAns': showAns && userSelectAns === ans && ans !== quizList[quizNum-1].corrAnsTc, 'trueAns': showAns && ans === quizList[quizNum-1].corrAnsTc
                }" (click)="selectAns(ans)">
                  <div>{{ ansLabel[key] }}.</div>
                  {{ ans }}
                </div>

              </div>
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <div class="col-12 col-md-4 col-lg-3 mb-4 mb-lg-5"
                *ngFor="let ans of quizList[quizNum-1].ansSc; let key = index;">

                <div class="ansBlock {{ getAnsBlockHeightStyle(quizList[quizNum-1]) }}" [ngClass]="{'pointer': !showAns, 'selectedAns': !showAns && ans === userSelectAns, 'disableAns': showAns && userSelectAns !== ans && ans !== quizList[quizNum-1].corrAnsSc, 'wrongAns': showAns && userSelectAns === ans && ans !== quizList[quizNum-1].corrAnsSc, 'trueAns': showAns && ans === quizList[quizNum-1].corrAnsSc
                }" (click)="selectAns(ans)">
                  <div>{{ ansLabel[key] }}.</div>
                  {{ ans }}
                </div>

              </div>
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <div class="col-12 col-md-4 col-lg-3 mb-4 mb-lg-5"
                *ngFor="let ans of quizList[quizNum-1].ansEn; let key = index;">

                <div class="ansBlock {{ getAnsBlockHeightStyle(quizList[quizNum-1]) }}" [ngClass]="{'pointer': !showAns, 'selectedAns': !showAns && ans === userSelectAns, 'disableAns': showAns && userSelectAns !== ans && ans !== quizList[quizNum-1].corrAnsEn, 'wrongAns': showAns && userSelectAns === ans && ans !== quizList[quizNum-1].corrAnsEn, 'trueAns': showAns && ans === quizList[quizNum-1].corrAnsEn
                }" (click)="selectAns(ans)">
                  <div>{{ ansLabel[key] }}.</div>
                  {{ ans }}
                </div>

              </div>
            </ng-container>
          </div>

          <div class="text-center py-3 mb-4 mb-lg-5">

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_tc.png" (click)="quizSubmit()"
                [ngClass]="{'disable': !userSelectAns }" *ngIf="!showAns">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/next_question_btn_tc.png" (click)="next()"
                *ngIf="showAns">
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_sc.png" (click)="quizSubmit()"
                [ngClass]="{'disable': !userSelectAns }" *ngIf="!showAns">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/next_question_btn_sc.png" (click)="next()"
                *ngIf="showAns">
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_en.png" (click)="quizSubmit()"
                [ngClass]="{'disable': !userSelectAns }" *ngIf="!showAns">
              <img class="img-fluid quizSubmit {{lang}}" src="{{imgpath}}/next_question_btn_en.png" (click)="next()"
                *ngIf="showAns">
            </ng-container>

          </div>

        </div>
      </div>

      <div class="row mx-0 justify-content-center" *ngIf="showResult">
        <div class="col-12 col-md-10 col-lg-8">

          <div class="text-center">
            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_tc.png" />
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_sc.png" />
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_en.png" />
            </ng-container>
          </div>

          <div class="row mx-0 mb-4">
            <div class="col-auto align-self-center pr-4 text-right">
              <ng-container *ngIf="lang === 'tc'">
                <img class="img-fluid scoreLabel" src="{{imgpath}}/score_tc.png" />
              </ng-container>
              <ng-container *ngIf="lang === 'sc'">
                <img class="img-fluid scoreLabel" src="{{imgpath}}/score_sc.png" />
              </ng-container>
              <ng-container *ngIf="lang === 'en'">
                <img class="img-fluid scoreLabel" src="{{imgpath}}/score_en.png" />
              </ng-container>
            </div>
            <div class="col">
              <div class="scoreContent">

                <!-- <img class="img-fluid" src="{{imgpath}}/award_gold.png" />
                <img class="img-fluid" src="{{imgpath}}/award_silver.png" />
                <img class="img-fluid" src="{{imgpath}}/award_copper.png" />
                <img class="img-fluid" src="{{imgpath}}/add_oil.png" /> -->
                <div class="score" [ngClass]="{'gold': getMark() === 100, 
                  'silver': (getMark() > 60 && getMark() < 100), 
                  'copper': (getMark() > 40 && getMark() < 70), 'addOil': (getMark() < 50)}">

                  <!-- {{ getTrueResultCounter() }} / {{ quizList.length }} -->
                  {{ getMark() }}

                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="dotLine mb-4"></div>
            <div class="resultContent text-center mb-4">

              <ng-container *ngIf="getMark() === 100">
                {{ label[lang].game1ResultGold }}
              </ng-container>
              <ng-container *ngIf="getMark() > 60 && getMark() < 100">
                {{ label[lang].game1ResultSilver }}
              </ng-container>
              <ng-container *ngIf="getMark() > 40 && getMark() < 70">
                {{ label[lang].game1ResultBronze }}
              </ng-container>
              <ng-container *ngIf="getMark() < 50">
                {{ label[lang].game1Result }}
              </ng-container>

              <!-- <table>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
              </table> -->

            </div>
            <div class="dotLine mb-3"></div>
          </div>

          <div class="py-4 text-center mb-4 mb-lg-5">
            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_tc.png" (click)="gameReset()" />
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_sc.png" (click)="gameReset()" />
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_en.png" (click)="gameReset()" />
            </ng-container>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="py-3 px-2">
    <!-- <small>{{ label[lang].commonRemark }}</small> -->
    <small>{{ label[lang].seedbankRemark1 }}</small>
    <br />
    <small>{{ label[lang].seedbankRemark2 }}</small>
    <br />
    <small>{{ label[lang].seedbankRemark3 }}</small>
  </div>

</div>